<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import EventBasicData from './form/BasicData'

  export default {
    components: {ListHeader, EventBasicData},
    props: ['eventId']
  }
</script>

<template>
    <div>
        <ListHeader title="Eventos"/>
        <el-card class="el-card__save_form box-card">
            <div slot="header">
                <span>Dados do Evento</span>
            </div>
            <event-basic-data :event-id="eventId"/>
        </el-card>
    </div>
</template>



// WEBPACK FOOTER //
// Store.vue?1e74f59a